/* eslint-disable jsx-a11y/img-redundant-alt */
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

import { SpaceBetweenContainer } from '../../../healtheraComponents';

export default function ImageUpload({
  imageUrl,
  helperText = 'Size and format suggestions',
  replace,
  error,
  inputProps,
  disabled
}) {
  return (
    <>
      <SpaceBetweenContainer>
        <Typography style={{ fontSize: 13, color: '#757575' }}>Image</Typography>
        <UploadLabel $disabled={disabled}>
          <input type="file" accept="image/png, image/jpeg" {...inputProps} />
          <span>{replace ? 'Change' : 'Select File'}</span>
        </UploadLabel>
      </SpaceBetweenContainer>
      <div>
        <ImageContainer>
          {imageUrl && <img src={imageUrl} alt="Selected image preview" />}
        </ImageContainer>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
      <Typography style={{ fontSize: 13, color: '#757575' }}>
        {helperText}
      </Typography>
    </>
  );
}

const UploadLabel = styled.label`
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  color: #519A71;
  cursor: pointer;

  & > input[type="file"] {
    display: none;
  }

  ${(props) => props.$disabled && `
    pointer-events: none;
    opacity: 0.5;
    cursor: default;
  `}
`;

const ImageContainer = styled.div`
  height: 160px;
  border: 1px solid #EFEFEF;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  & > img {
    width: 100%;
    height: 100%;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 13px;
  text-align: center;
  margin: 4px 0 0 0;
`;
